<!--
 * @Author: rossdong@yntengyun.com
 * @Date: 2024-10-15 11:29:13
 * @Description: b 考核项的，首页
-->
<template>
    <div class="container">
        <div class="head">
            <div class="title">
                <div class="text">{{ assessName }}</div>
                <div class="flex-row f-s-s mt-8">
                    <span> {{ areaName }}</span>
                    <span class="ml-8">{{ quarterName }}</span>
                </div>
            </div>
            <div class="rules">
                <div v-if="Number(ls_deduction) == 0" class="no-de">未扣分</div>
                <div v-else class="branch">-{{ ls_deduction }}</div>
                <div class="num">{{ ls_score }}/{{ ls_sumScore }}</div>
            </div>
        </div>
        <!-- 列表  -->
        <template v-if="recordList && recordList.length > 0">
            <div class="card-bg mt-16 mx-12">
                <div class="flex flex-row mt-16 px-12 pb-12" v-for="(item, index) in recordList" :key="index"
                    :style="index != recordList.length - 1 ? 'border-bottom: 1px #EEEEEE solid' : ''">
                    <!-- left -->
                    <div class="flex-1 flex flex-col ">
                        <div class="text-16 text-[#333333] font-bold">{{ item.projectname }}</div>
                        <div class="mt-16 text-14 text-[#333333] font-400">
                            <div v-if="item.type == 'B1'"> {{ item.subtitle }} : {{ item.respoutNum }} 件</div>
                            <span v-if="item.type == 'B2'"> {{ item.subtitle }} : {{ item.doneoutNum }} 件</span>
                            <span v-if="item.type == 'B3'"> {{ item.subtitle }} : {{ item.doneinRate / 100 }}%</span>
                        </div>
                        <div class="mt-16 text-[#36b374] flex items-center w-180 h-12" @click="queryMore(item)">
                            <div class="">查看详情</div>
                            <img src="../../../assets/image/tb-right.png" class="object-contain size-16" />
                        </div>
                    </div>
                    <!-- right -->
                    <div class=" flex flex-col items-center">
                        <div class="text-[#FF4D4D] font-bold text-12 leading-12">-{{ item.deduction / 100 }}分</div>
                        <div class="text-[#FF4D4D] font-bold text-12 leading-12"
                            v-if="(item.type == 'B1' && item.respoutNum >= 10) || (item.type == 'B2' && item.doneoutNum >= 10)">
                            已达扣分上限
                        </div>
                    </div>
                </div>

            </div>
        </template>
        <!-- 没有扣分记录提示 -->
        <div v-else class="noData-bg">
            <nodata :noData="noData"></nodata>
        </div>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import nodata from "../components/nodata"; // 没有数据
import deducList from "./components/deducList"; // 扣分列表

import API from "../../../service/index";
import commonAPI from "../../../utils/common";
import { type } from "@/utils/configJson";

export default {
    // import引入的组件需要注入到对象中才能使用
    components: {
        nodata,
        deducList,
    },
    name: 'index',
    props: {

    },
    data() {
        // 这里存放数据
        return {
            assessName: this.$route.query.assessName,
            noData: {
                title: "暂无数据",
            },
            recordList: [],
            asscessType: "",
            quarterName: this.$route.query.quarterName,
            ls_deduction: 0,
            ls_sumScore: 0,
            ls_score: 0,
            year: this.$route.query.year,
            quarter: this.$route.query.quarter,
            area: this.$route.query.area,
            areaName: this.$route.query.areaName,
        };
    },
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        getdeductionList(year, quarter, area) {
            API.getBCateogryDeductionList({ year, quarter, area }).then((res) => {
                console.log("-----列表:", res);
                if (res.ret == 0) {
                    // this.recordList = res.data.list;
                    this.ls_deduction = res.data ? (res.data.totalDeduction / 100).toFixed(2) : 0;
                    this.ls_sumScore = res.data ? (res.data.totalScore / 100).toFixed(1) : 0;
                    this.ls_score = (this.ls_sumScore - this.ls_deduction).toFixed(2);


                    // web 字段 respoutNum b1
                    let fiveMinutes = {
                        ...res.data.fiveMinutes,
                        projectname: "投诉五分钟内未响应情况",
                        subtitle: "5分钟未响应量",
                        type: "B1",
                    }
                    //b2
                    let hoursOuts = {
                        ...res.data.hoursOuts,
                        projectname: "投诉超24小时未办结情况",
                        subtitle: "24小时未办结量",
                        type: "B2",

                    }
                    // b3 
                    let finishRate = {
                        ...res.data.finishRate,
                        projectname: "投诉办结率24小时未达95%",
                        subtitle: "24小时办结率",
                        type: "B3",
                    }
                    this.recordList = [fiveMinutes, hoursOuts, finishRate]
                }
            });
        },

        queryMore(value) {
            let params = {
                year: this.year,
                quarter: this.quarter,
                area: this.area,
                currentPage: 1,
                pageSize: 5
            }
            if (value.type === 'B1') {
                this.$router.push({ path: '/appraise/deducList_FivemitnusAll', query: { ...value, dealType: value.type, ...params ,quarterName:this.quarterName} });
            } else if (value.type === 'B2') {
                this.$router.push({ path: '/appraise/deducList_twfoNOAll', query: { ...value, dealType: value.type, ...params ,quarterName:this.quarterName} });
            } else if (value.type === 'B3') {
                // this.$router.push({ path: '/appraise/deducList_twfoAll', query: { ...value, dealType: value.type, ...params ,quarterName:this.quarterName} });
                this.$router.push({ path: '/appraise/nintyFivePercent', query: { ...value, dealType: value.type, ...params ,quarterName:this.quarterName} });
            }
        },
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        console.log('output->[ created ] >', this.$route.query)
        this.getdeductionList(this.year, this.quarter, this.area)
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { }, // 生命周期 - 销毁完成
    activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
//  @import url(); 引入公共css类
.card-bg {
    background-color: #fff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
    border-radius: 3px;
    padding-bottom: 12px;
}

.container {
    min-height: 100vh;
    background: #fbfbfb;
    display: flex;
    flex-direction: column;
    position: relative;

    .noData-bg {
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 1;
    }

    .head {
        background: #fff;
        padding: 20px 12px;
        display: flex;
        justify-content: space-between;

        .title {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding-right: 50px;

            .text {
                font-size: 20px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: bold;
                color: rgba(51, 51, 51, 1);
                line-height: 28px;
            }

            .tit {
                position: relative;
                display: flex;
                color: #999;
                font-size: 12px;
                margin-top: 12px;

                span {
                    position: relative;
                    padding-right: 16px;
                }

                span::after {
                    content: "";
                    position: absolute;
                    right: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 12px;
                    height: 12px;
                    background: url(../../../assets/image/t-right.png) no-repeat;
                    background-size: 12px 12px;
                }
            }
        }

        .rules {
            display: flex;
            flex-direction: column;
            color: #666666;
            text-align: right;

            .num {
                color: #999999;
                font-size: 14px;
                margin-top: 8px;
            }

            .branch {
                height: 22px;
                font-size: 22px;
                // font-family: DIN-Medium, DIN;
                font-weight: 500;
                color: rgba(255, 77, 77, 1);
                line-height: 28px;
            }

            .no-de {
                min-width: 60px;
                font-size: 20px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: bold;
                color: #999;
                line-height: 22px;
            }
        }
    }
}
</style>